import React from 'react';
import { Box, Typography } from '@mui/material';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import { colors } from '../../theme/tokens';

const badges = [
  { icon: <WorkspacePremiumOutlinedIcon />, label: '25+ years experience' },
  { icon: <VerifiedUserOutlinedIcon />, label: 'Licensed & insured' },
  { icon: <StarRoundedIcon sx={{ color: colors.star }} />, label: '5-star Google reviews' },
  { icon: <PlaceOutlinedIcon />, label: 'Based in Kingsbury, NW9' },
];

type TrustBadgesProps = {
  compact?: boolean;
  justify?: 'flex-start' | 'center';
};

const TrustBadges: React.FC<TrustBadgesProps> = ({ compact = false, justify = 'flex-start' }) => (
  <Box
    component="ul"
    sx={{
      listStyle: 'none',
      m: 0,
      p: 0,
      display: 'flex',
      flexWrap: 'wrap',
      gap: compact ? 1.5 : { xs: 1.5, md: 3 },
      justifyContent: justify,
    }}
  >
    {badges.map((badge) => (
      <Box
        component="li"
        key={badge.label}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          color: colors.textMuted,
          fontSize: compact ? '0.85rem' : '0.92rem',
          fontWeight: 500,
          '& svg': { fontSize: 20, color: colors.accent },
        }}
      >
        {badge.icon}
        <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit' }}>
          {badge.label}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default TrustBadges;
